import React, { useCallback, useContext, useEffect, useState } from 'react';
import { CompactViewContext } from '../Providers/CompactViewProvider';
import useEmblaCarousel from 'embla-carousel-react';
import { Carousel } from './Carousel';
import { EmblaContainer } from './EmblaContainer';
import { GradientEdge } from './GradientEdge';
import { useFrodorModules } from '../../../../Context/FrodorModulesProvider';
export const EmblaCarousel = ({ slides, numberOfSlidesToShow = 5, videoIdx, setVideoIdx, scrollNext, scrollPrev, renderSlide, }) => {
    const { isCompact } = useContext(CompactViewContext);
    const { dir } = useFrodorModules();
    const [hasInteracted, setHasInteracted] = useState(false);
    const offset = isCompact ? 0 : 2;
    const currentVideoIdx = videoIdx + offset + 1;
    const setCurrentVideoIdx = useCallback((n) => {
        setVideoIdx(n - offset - 1);
    }, [offset, setVideoIdx]);
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: 'center',
        startIndex: offset,
        containScroll: 'keepSnaps',
        duration: 20,
        direction: dir,
    });
    useEffect(() => {
        emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(currentVideoIdx - 1);
    }, [emblaApi, currentVideoIdx, slides, offset]);
    useEffect(() => {
        emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.on('select', () => {
            const newSelectedVid = ((emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.selectedScrollSnap()) + 1) % slides.length;
            setCurrentVideoIdx(newSelectedVid);
        });
    }, [emblaApi, slides.length, setCurrentVideoIdx]);
    const getAffordanceState = useCallback((idx) => {
        const offsetIndex = (idx + offset + 1) % slides.length;
        const nextAffordanceVideoIdx = isCompact
            ? (currentVideoIdx + 1) % slides.length
            : (currentVideoIdx + numberOfSlidesToShow) % slides.length;
        const prevAffordanceVideoIdx = (currentVideoIdx - 1 + slides.length) % slides.length;
        if (offsetIndex === nextAffordanceVideoIdx) {
            return 'right';
        }
        if (offsetIndex === prevAffordanceVideoIdx) {
            return 'left';
        }
        return null;
    }, [currentVideoIdx, isCompact, numberOfSlidesToShow, slides.length, offset]);
    return (React.createElement(Carousel, { className: "embla", ref: emblaRef, isCompact: isCompact },
        React.createElement(EmblaContainer, { numberOfVideosToShow: numberOfSlidesToShow, numVideos: slides.length, className: "embla__container", isCompact: isCompact }, slides.map((vid, idx) => {
            const affordanceState = getAffordanceState(idx);
            return (React.createElement("div", { className: "embla__slide", role: "button", key: `embla-slide-${idx}`, onKeyUp: e => {
                    if (e.key === 'Space') {
                        if (affordanceState === 'right') {
                            scrollNext();
                        }
                        if (affordanceState === 'left') {
                            scrollPrev();
                        }
                    }
                }, onClick: () => {
                    if (!hasInteracted)
                        setHasInteracted(true);
                    if (affordanceState === 'right') {
                        scrollNext();
                    }
                    if (affordanceState === 'left') {
                        scrollPrev();
                    }
                }, onFocus: () => {
                    if (!hasInteracted)
                        setHasInteracted(true);
                }, onMouseEnter: () => {
                    if (!hasInteracted)
                        setHasInteracted(true);
                }, tabIndex: 0 }, renderSlide({
                affordanceState,
                vid,
                idx,
                hasInteracted,
            })));
        })),
        React.createElement(GradientEdge, { className: "gradient-edge", toLeft: true }),
        React.createElement(GradientEdge, { className: "gradient-edge", toRight: true })));
};
//# sourceMappingURL=index.js.map